import React, { useState } from "react";
import { Card, Form, Input, Button, Typography, message, Row, Col } from "antd";
import { UserOutlined, LockOutlined, LoginOutlined } from "@ant-design/icons";
import axiosInstance from "../../configs";

const { Title, Text } = Typography;

export default function LoginPage() {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);

      const res = await axiosInstance.post("/auth/login", {
        username: values.username,
        password: values.password,
      });

      if (res.data?.success) {
        const { token, refreshToken, user, permissions } = res.data.data;

        localStorage.setItem("token", token);
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("permissions", JSON.stringify(permissions || []));

        message.success("Login berhasil");

        // KARENA pakai HashRouter → redirect ke #/dashboard
        window.location.hash = "#/dashboard";
      } else {
        message.error(res.data?.message || "Login gagal");
      }
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.message || "Terjadi kesalahan saat login";
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background:
          "linear-gradient(135deg, #80d0ff 0%, #c2e9fb 50%, #ffffff 100%)",
      }}
    >
      <Row
        gutter={[32, 32]}
        justify="center"
        align="middle"
        style={{ width: "100%", maxWidth: 1000 }}
      >
        {/* LEFT PANEL: Branding - Hidden on mobile */}
        <Col xs={0} sm={0} md={12}>
          <div
            className="login-left-panel"
            style={{
              height: "100%",
              minHeight: 450,
              color: "#0b5394",
              padding: "32px 28px",
              borderRadius: 24,
              background:
                "linear-gradient(145deg, rgba(255,255,255,0.9), rgba(210, 240, 255, 0.8))",
              border: "1px solid rgba(0,123,255,0.25)",
              boxShadow: "0 20px 45px rgba(0, 132, 255, 0.25)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  padding: "6px 12px",
                  borderRadius: 999,
                  backgroundColor: "#eaf6ff",
                  color: "#0b5394",
                  border: "1px solid rgba(0,123,255,0.25)",
                  marginBottom: 16,
                  fontSize: 12,
                  letterSpacing: 0.3,
                  textTransform: "uppercase",
                }}
              >
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: "#0ea5e9",
                    marginRight: 8,
                  }}
                />
                Atlantik Logistik Berikat
              </div>

              <h1
                style={{
                  fontSize: 28,
                  lineHeight: 1.35,
                  fontWeight: 700,
                  marginBottom: 12,
                }}
              >
                Kelola stok & laporan{" "}
                <span style={{ color: "#0284c7" }}>lebih cepat & efisien</span>.
              </h1>

              <p
                style={{
                  fontSize: 14,
                  color: "#0b5394",
                  opacity: 0.85,
                  maxWidth: 380,
                }}
              >
                Pantau pemasukan, pengeluaran, stripping, dan data pabean melalui
                dashboard yang praktis dan ringan.
              </p>
            </div>

            <div
              style={{
                fontSize: 12,
                color: "#0b5394",
                opacity: 0.7,
                marginTop: 24,
              }}
            >
              Tip: Jangan bagikan username & password anda.
            </div>
          </div>
        </Col>

        {/* RIGHT PANEL: Login Card */}
        <Col xs={{ span: 24, order: 1 }} md={{ span: 12, order: 2 }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Card
              style={{
                width: "100%",
                maxWidth: 420,
                borderRadius: 24,
                background: "white",
                border: "1px solid rgba(0,123,255,0.15)",
                boxShadow: "0 20px 45px rgba(0,132,255,0.20)",
              }}
              bodyStyle={{ padding: "32px 28px" }}
            >
              <div style={{ marginBottom: 24, textAlign: "center" }}>
                <img
                  src="/assets/media/logos/alb.png"
                  alt="Logo"
                  style={{
                    height: 80,
                    margin: "0 auto 16px",
                    display: "block",
                  }}
                />

                <Text style={{ color: "#0b5394", opacity: 0.7, fontSize: 13 }}>
                  Silahkan login untuk memulai aktifitas.
                </Text>
              </div>

              <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
                <Form.Item
                  label={<span style={{ color: "#0b5394" }}>Username</span>}
                  name="username"
                  rules={[{ required: true, message: "Username wajib diisi" }]}
                >
                  <Input
                    size="large"
                    prefix={<UserOutlined style={{ color: "#0ea5e9" }} />}
                    placeholder="Masukkan username"
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ color: "#0b5394" }}>Password</span>}
                  name="password"
                  rules={[{ required: true, message: "Password wajib diisi" }]}
                >
                  <Input.Password
                    size="large"
                    prefix={<LockOutlined style={{ color: "#0ea5e9" }} />}
                    placeholder="Masukkan password"
                  />
                </Form.Item>

                <Form.Item style={{ marginTop: 12 }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    icon={<LoginOutlined />}
                    block
                    loading={loading}
                    style={{
                      borderRadius: 999,
                      fontWeight: 600,
                      background:
                        "linear-gradient(135deg, #38bdf8, #0ea5e9, #0284c7)",
                      border: "none",
                      boxShadow: "0 10px 25px rgba(14,165,233,0.4)",
                    }}
                  >
                    Login
                  </Button>
                </Form.Item>
              </Form>

              <div style={{ textAlign: "center", marginTop: 10 }}>
                <Text style={{ color: "#0b5394", opacity: 0.7, fontSize: 11 }}>
                  © {new Date().getFullYear()} Atlantik Logistik Berikat
                </Text>
              </div>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  );
}
